import FingerprintJS from "@fingerprintjs/fingerprintjs"

import { BROWSER_STORAGE_KEYS } from "./constants"

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load()

export const getFingerprint = async () => {
  try {
    const fp = await fpPromise
    const result = await fp.get()

    // This is the visitor identifier:
    const { visitorId } = result
    return visitorId
  } catch (error) {
    console.error(error)
    let tempDeviceId = localStorage.getItem(BROWSER_STORAGE_KEYS.tempDeviceId)
    if (tempDeviceId !== null) {
      return tempDeviceId
    }
    tempDeviceId = `fail-${Date.now()}`
    localStorage.setItem(BROWSER_STORAGE_KEYS.tempDeviceId, tempDeviceId)
    return tempDeviceId
  }
}
